import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'
import { TableHelper } from '../../../../tables'

import { AssignmentTable } from '../../../../tables/assignment-table'

const ScheduledAssignments: React.FunctionComponent = observer(() => {
  const { assignmentStore } = useStores()
  const { setTriggerRefresh, triggerRefresh } = assignmentStore

  const [tableHelper] = useState(
    new TableHelper(
      'list_scheduled_assignments',
      'assignments',
      'assignments',
      undefined,
      'scheduled',
    ),
  )

  useEffect(() => {
    if (triggerRefresh) {
      tableHelper.load().then(() => setTriggerRefresh(false))
    }
  }, [triggerRefresh])

  return (
    <AssignmentTable forceLoading={triggerRefresh} filter="scheduled" tableHelper={tableHelper} />
  )
})

export const ScheduledAssignmentsTab = () => {
  return {
    name: 'Scheduled',
    path: `/activities/assignments/scheduled`,
    component: () => <ScheduledAssignments />,
  }
}
